import axios from "axios";
import {notification} from 'antd';
import countries from '../../static/json/countries.json'

/** *
* *Frequently used functions and constants
*/
export const IP = "https://back.premiocasa.cult.cu/"// IP used for API requests
export const logout=async()=>{//logout from system
    await fetch(IP + 'api/logout',{
      method: "post",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
    },
    }).then(result=>{
      if(result.status == 200){
        var userId = localStorage.getItem("UserId")
        const data_log= new FormData()
        data_log.append('usuario',userId)
        data_log.append('accion',"Salida del sistema")
      
        // axios.post(IP + 'api/composicion/logs/', data_log)
        localStorage.clear()
        window.location.reload(); 
      }
      else{
        notification.error({
      message:'Error',
      description:'Hubo un error, por favor intente más tarde',
    })}
    })
}

export const getAuthors=(auth)=>{//receives dict of authors items and builds dict of authors names with key
  var authors = []
  for (var i in auth){
    authors.push({id:i,
      name: auth[i]["nombre_completo"]} )
  }
  return authors
}
export const getAuthorsStr=(auth)=>{//receives dict of authors items and builds array of authors names
  var authors = []
  for (var i in auth){
    authors.push( auth[i]["nombre_completo"])
  }
  return authors
}

export const getCountryName=(country)=>{//given a country code, gets its name defined in countries.json
    for(var c in  countries["countries"]){
      if (countries["countries"][c]["code"]==country)
        return countries["countries"][c]["name_es"]
    }
    return "No name"
}

export const getCountryCode = (country)=>{//given a country name, gets its code defined in countries.json
  for(var c in  countries["countries"]){
    if (countries["countries"][c]["name_es"]==country)
      return countries["countries"][c]["code"]
  }
  return "No code"
}

export const centerStyle = {// style used to center items, mostly in menus
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignElements:'center',
};

export const countDownNotification = (_notification, message, description, key) =>{//pops up notification that hides automatically in 4 seconds
  let secondsToGo = 4;
  _notification({
      key: key,
      message: message + `(${secondsToGo}).`,
      description: description
  });
  const timer = setInterval(() => {
      secondsToGo -= 1;
      _notification({
          key: key,
          message: message + `(${secondsToGo}).`,
          description: description,
          onClose: () => clearInterval(timer),
      });
  }, 1000);
  setTimeout(() => {
      clearInterval(timer);
      notification.close(key);
  }, secondsToGo * 1000);
}

export const downloadFile=(record)=>{
  var downloadUrl = IP + 'api/composicion/file/'+ record.id
  const link = document.createElement('a');
        link.href =  downloadUrl;
        document.body.appendChild(link);
        link.click();
  
    // fetch(downloadUrl, {
    //   method: "GET",
    //   headers: {
    //     "Content-Type": "application/zip"
    //   }
    // })
    //   .then(res => res.blob())
    //   .then(response => {
    //     //Create a Blob from the PDF Stream
    //     console.log(response);
    //     const blob = new Blob([response], {
    //       type: "application/zip"
    //     });
    //     //Build a URL from the file
    //     // const fileURL = URL.createObjectURL(file);
  
    //     const link = document.createElement('a');
    //     // create a blobURI pointing to our Blob
    //     link.href = downloadUrl;
    //     link.download = record.code;
    //     // some browser needs the anchor to be in the doc
    //     document.body.append(link);
    //     link.click();
    //     link.remove();
    //     // in case the Blob uses a lot of memory
    //     setTimeout(() => URL.revokeObjectURL(link.href), 7000);
    //     //Open the URL on new Window
    //     // window.open(fileURL);
    //   })
    //   .catch(error => {
    //     console.log(error);
    //   });
  }

  export const readFile =  (pdf)=>{
    window.open(pdf)
  };

  export const getComments = async(playId)=>{
    const comments = await fetch(IP + `api/casa/composicion/?obra=${playId.toString()}`,{ method: "get",
    credentials: "same-origin",
    headers: {
      "Authorization": localStorage.getItem("Authorization") ,
      "Accept": "application/json",
      "Content-Type": "application/json"}})
    const json_comments = await comments.json();
    const comments_dict = {}
    if(json_comments['detail']){
      notification.error({
        message:'Error',
        description:'Hubo un error cargando los comentarios, por favor intente más tarde',
      })
      return {}
    }
    else{
      json_comments.forEach(element => {
        comments_dict[element.id] = element
        });
      return comments_dict
    }
  }
  